
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaVMXMDcZ8hOJLh0TfSCmKzWd9yhhfAnez9xB2pW0bMQMeta } from "/codebuild/output/src3697371726/src/pages/index.vue?macro=true";
import { default as index1GN_45qEUuObqOLPAxbA4QZDcBaIZ6S95Sb_T4ZnhcbhIMeta } from "/codebuild/output/src3697371726/src/pages/login/index.vue?macro=true";
import { default as indexKAY_Gnpq9izpgBbU9tEGojd5zJ9jF74Oc9g0M1kBcVEMeta } from "/codebuild/output/src3697371726/src/pages/software/index.vue?macro=true";
import { default as index0KH7JjfP1c7j1WdDuPCA1BqqezaAu1Mm9WIECL6CPagMeta } from "/codebuild/output/src3697371726/src/pages/trackers/index.vue?macro=true";
import { default as indexuGZoluSyPprA9vkqVMG7VGrakAiAKdlaY1kTgCsF7kIMeta } from "/codebuild/output/src3697371726/src/pages/templates/index.vue?macro=true";
import { default as createW5Wa_NSvvlswU3qJi7UZfdD98VnMg1Sp2261zNjf8YcMeta } from "/codebuild/output/src3697371726/src/pages/trackers/create.vue?macro=true";
import { default as creategmpg0wjQJxuZ5P1o9Yb89hJQx8oqZv4HpaGH0jl5RkIMeta } from "/codebuild/output/src3697371726/src/pages/templates/create.vue?macro=true";
import { default as index345ZNN0a_LzXWGPQ_45M8wi_45sx9plPUrbWSQrambSCeU4Meta } from "/codebuild/output/src3697371726/src/pages/tagging-docs/index.vue?macro=true";
import { default as editAhU_45cL_0p8p3MHHQpiYBUPW8SrAJOEhqcqi5YJsXYKUMeta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_938kKkvRnc_45uez9fYE0YXG06iw8wO8I0pkSLM4QMk0jXoMeta } from "/codebuild/output/src3697371726/src/pages/login/token/[token].vue?macro=true";
import { default as editwjzPKCRxGtamnN9QkKGIFaKaA1gvASvnk_458eeTx_4511kMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/edit.vue?macro=true";
import { default as indextEERR3QdsLzLQB9iRmC2ZxtPsLrpD7U_YmHuD_45j5vpoMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/index.vue?macro=true";
import { default as index801_GTjQW4TiuQqRqNgy0TctpCo1tjYeDRoDOMwBGlgMeta } from "/codebuild/output/src3697371726/src/pages/plan-management/index.vue?macro=true";
import { default as indexfe2id4RbW1_45mNfkw7h7_mCxmsbJCYeVLwz9uup3oxgEMeta } from "/codebuild/output/src3697371726/src/pages/dropcode-generator/index.vue?macro=true";
import { default as index3Buve62FeciCR5wGBAp_CLhRgj0DOzcxIF3hYcdDhIQMeta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as indexIhJVHvsDrw0SELPW3_458DN8qus3cD_RAPFqz0XOMNoe0Meta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as index_45km_456eLXdUkqGtG4MQe_LCw3PUG_45_45azcLdOnP8AEzLsMeta } from "/codebuild/output/src3697371726/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as createKr8VCJmwP8l9unFG5FEXBhI_45D3ZEsEWmJipsE_pe8usMeta } from "/codebuild/output/src3697371726/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as editJgOzq4t4tM_NcokbHMOG_45dAnLeiXMEFdVmBnemumfo4Meta } from "/codebuild/output/src3697371726/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsP_MFnNTsDvUSJpr56VPgdpaw2VD_45hgDYGPJXY3SfVP4Meta } from "/codebuild/output/src3697371726/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as indexa1d5rDn9ZycI4GorhcDYhldg9zvCQomr7Iqs0uz_4iYMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as createNKz9HlvZUQMfASZ4Q4wwtuwk2cVlbqc8iCUIbNThvpsMeta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groupso_j66nC7y98MUR_45a3ZztCT41D8jk5dTtPfpbwvC9JOAMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as createThWYZgpyKjKlc62U_45v0XOXj5TG5iy63kMOt9Fvvl3KgMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as indexYnpNGS9pphirgRVI8ksqdNrx4SzfTwqXlB_y8ehhwYwMeta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexiPoxH8qTTNPfZFaMH2ettv9Xr77AZxEzMwJKij68QuQMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as create3YoHQOQl_45Wxhliji_iG8TSBzHsGzLxfV5_M78BagGfAMeta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backendwSfWT4kGoFKWkES4pmsTn4qWtgXdEi5zwFVsS3Tp348Meta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as createroOmpEPfNK3vsHmVq5nWhcrUj3_45CmjWOXWRxlTF3oTcMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontenddUDm2djzEPhXQdDL2Qhf4xItRQYJKGazpbB70gjAuikMeta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePageGVocL9_dCvLNCt_jkdmKoObrmpwvPm6elZ3EDHYAQf8Meta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as indexmscYaUa1fQOouGU4_nCvXvIz_45XEW_45oD7k9n96YSwRb4Meta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as index57zOb4TT86qw4RXv8ldqgWvoBt7h3rET7qZ7yIW3z08Meta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownership_459ZJLpG_45AzGQ2Stg8iml_e_45A8EROupo0gAyd8yQ0CWQMeta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as indexOrxsKK7hLIUubapWGgCtYRoD02hWXQtNoQhHut51a_QMeta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as indexUVQ7SVXtorqr3fHpO_pOlYsZKoTN5hMnmaiL9ecvJJwMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontendZRn1KI4O2sv_zeYKSlflOax9nrP4UrqhIkijsxjN4GYMeta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v2un9z4e1E01AOYZ6EXda4_XM82jG0FLZHJZ88MJ4s7TcMeta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as editY9lQsqK3S_BYn_45K4ihvjw_45k3FafDVqdTLTX8qu18w6MMeta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editWRA58hMfCBAhTvFTv5TRddA3Ekj_oxXRp4xaWOSeyyEMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45componentsr4hwi_45rwQiU8Wh_45uyElh0SQYtnnsVVZzjFGk3hQcjTIMeta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45salesKHCtS7_458BySe8XFsP8Tklyn91qUmMfRS2u1ytFiAzRgMeta } from "/codebuild/output/src3697371726/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as indexGw_BXlCMTMP61xqXT9sRJ839_45ypgSWPadevAtG_45MEe8Meta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexteWn_45T_45Ui4vRcFdfdLBf3_oxJAsyRl9umWuWIvkdKp8Meta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as createnaRRBev6kUkr_t7Q7GuZp3Fb72wQjtbCUe5hwjrdsNYMeta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as create5YRSpXpdggYEZC9lLRXvg3y6G1pnGc_45R8ARloIBfiEkMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as editLmcNCNIEr4uATGYBusX8hJpi17vxyqbKoxxzcs4gxvgMeta } from "/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editx5OPY65PcWq_45_45iqkIg1_iQsbxvoK_45oI_K2hNRIHp9asMeta } from "/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3697371726/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src3697371726/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src3697371726/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src3697371726/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src3697371726/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src3697371726/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src3697371726/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsP_MFnNTsDvUSJpr56VPgdpaw2VD_45hgDYGPJXY3SfVP4Meta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src3697371726/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src3697371726/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src3697371726/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src3697371726/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3697371726/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]